const MEDIA_ITEMS = [
  {
    thumb: 'https://readdy.ai/api/search-image?query=Manga%20drawing%20tutorial%20video%20thumbnail%20style%2C%20artist%20hand%20sketching%20character%2C%20warm%20lighting%2C%20creative%20workspace%2C%20Japanese%20manga%20aesthetic%2C%20clean%20composition&width=640&height=360&seq=media-01&orientation=landscape',
    title: '漫画创作幕后：从分镜到成稿',
    desc: '人气漫画家分享创作全过程，揭秘一话漫画的诞生',
    duration: '12:38',
    views: '8.2万',
  },
  {
    thumb: 'https://readdy.ai/api/search-image?query=Webtoon%20review%20and%20recommendation%20thumbnail%20style%2C%20colorful%20manga%20covers%20arranged%2C%20warm%20vibrant%20colors%2C%20cozy%20aesthetic%2C%20clean%20cream%20background&width=640&height=360&seq=media-02&orientation=landscape',
    title: '七月新番测评：这五部必须追',
    desc: '编辑部精选七月必追新番，帮你避开烂番找到好作品',
    duration: '18:25',
    views: '5.6万',
  },
  {
    thumb: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20artist%20interview%20thumbnail%20style%2C%20digital%20drawing%20tablet%20with%20webtoon%20panels%2C%20warm%20studio%20lighting%2C%20creative%20atmosphere%2C%20clean%20composition&width=640&height=360&seq=media-03&orientation=landscape',
    title: '对话韩漫大神：灵感与创作之路',
    desc: '独家专访热门韩漫作者，了解创作背后的故事与坚持',
    duration: '25:10',
    views: '3.9万',
  },
  {
    thumb: 'https://readdy.ai/api/search-image?query=Chinese%20manhua%20industry%20documentary%20thumbnail%2C%20animation%20studio%20with%20artists%20working%2C%20warm%20creative%20environment%2C%20professional%20setup%2C%20clean%20composition&width=640&height=360&seq=media-04&orientation=landscape',
    title: '国漫崛起：从代工到原创的蜕变',
    desc: '深度解析国漫产业发展历程，见证中国漫画的飞跃进步',
    duration: '32:42',
    views: '12.1万',
  },
];

export default function Media() {
  return (
    <section id="media" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-screen-2xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">
            精彩视频
          </h2>
          <p className="text-sm text-foreground-500 max-w-lg mx-auto">
            漫画资讯、创作幕后、新番测评一网打尽
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {MEDIA_ITEMS.map((item, i) => (
            <div
              key={i}
              className="group rounded-xl overflow-hidden bg-background-50 border border-background-200/60 hover:border-accent-200 transition-all duration-300 cursor-pointer"
            >
              <div className="relative aspect-video overflow-hidden">
                <img
                  src={item.thumb}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 flex items-center justify-center">
                  <div className="w-12 h-12 flex items-center justify-center rounded-full bg-background-50/90 text-primary-600 group-hover:bg-primary-500 group-hover:text-background-50 transition-all duration-300">
                    <i className="ri-play-fill text-xl ml-0.5"></i>
                  </div>
                </div>
                <span className="absolute bottom-2 right-2 px-1.5 py-0.5 rounded bg-black/70 text-background-50 text-xs whitespace-nowrap">
                  {item.duration}
                </span>
              </div>
              <div className="p-4">
                <h3 className="text-sm font-heading font-bold text-foreground-900 mb-1.5 group-hover:text-accent-600 transition-colors line-clamp-2">
                  {item.title}
                </h3>
                <p className="text-xs text-foreground-500 mb-2 line-clamp-2">{item.desc}</p>
                <span className="text-xs text-foreground-400">{item.views} 次观看</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}